export default __webpack_public_path__ + "static/media/carousel-isp-mdu-01.e4b18c4a.png";